import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class BillingControlService {

  private apiUrl = globalConst.baseAPI;

  public selectedDirectorship; // Set directorship to filter billing control data.
  public selectedDirectorshipDescription; // Set directorship to show description.
  public BCDays = 0;

  constructor(private http: Http) { }

  setBCDays() {
    this.getBCDays().subscribe(result => {
      const tempObj = result.Result.filter(item => item.Chave == "cdias");
      this.BCDays = +tempObj[0].Valor;
    }, error => {
      console.log(error);
    });
  }

  getBCDays() {
    return this.http
      .get(this.apiUrl + "/system/v1/getcodparameterstype/cobranca", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBCGeneral() {
    const idToGet = this.selectedDirectorship ? this.selectedDirectorship : "";
    return this.http
      .get(this.apiUrl + "/collect/v1/generaldir/" + idToGet, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBCEffective() {
    const idToGet = this.selectedDirectorship ? this.selectedDirectorship : "";
    return this.http
      .get(this.apiUrl + "/collect/v1/effectivedir/" + idToGet, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBCEffectiveStatus() {
    const idToGet = this.selectedDirectorship ? this.selectedDirectorship : "";
    return this.http
      .get(this.apiUrl + "/collect/v1/effectivestat/" + idToGet, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBCEffectiveUF(showAll) {
    const idToGet = this.selectedDirectorship ? this.selectedDirectorship : "";
    const filter = showAll ? "" : "?$orderby=Total desc&$top=10";
    return this.http
      .get(this.apiUrl + "/collect/v1/effectiveuf/" + idToGet + filter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBCRecent(showAll) {
    const idToGet = this.selectedDirectorship ? this.selectedDirectorship : "";
    const filter = showAll ? "" : "?$orderby=Valor desc&$top=10";
    return this.http
      .get(this.apiUrl + "/collect/v1/recentoverdue/" + idToGet + filter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBCLargest(showAll) {
    const idToGet = this.selectedDirectorship ? this.selectedDirectorship : "";
    const filter = showAll ? "" : "?$orderby=Total desc&$filter=Total ge 1";
    return this.http
      .get(this.apiUrl + "/collect/v1/greatoverdue/" + idToGet + filter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBCCulture(showAll) {
    const idToGet = this.selectedDirectorship ? this.selectedDirectorship : "";
    const filter = showAll ? "" : "?$orderby=Total desc&$top=10";
    return this.http
      .get(this.apiUrl + "collect/v1/effectivecult/" + idToGet + filter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBCSentToJudicial() {
    const idToGet = this.selectedDirectorship ? this.selectedDirectorship : "g"; // g = geral
    return this.http
      .get(this.apiUrl + "juridical/v1/getcontrol/" + idToGet, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/service/billing-control.service.ts